export default __webpack_public_path__ + "static/media/downArrow.42337072.svg";